import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

const usePmcsMarketing = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);

  const featureEnabled = useEnabledFeature('cat-pmcs');
  const segmentEnabled = useEnabledSegment(`${abbrBrand}56`);

  return featureEnabled && segmentEnabled;
};

export default usePmcsMarketing;
